import { ref } from '@vue/composition-api'
import { DataService } from '@/services/DataService.js'

export default function useEmail () {
  const isEmailOpened = ref(false)

  var entity = ref(null)
  var entityId = ref(null)

  var email = ref({
    suggestions: [],
    recipients: [],
    ccRecipients: [],
    subject: null,
    content: null,
    files: []
  })

  const newEmail = ({ entity: ety, entityId: etyId, files }) => {
    DataService.emailTemplate({ entity: ety, entityId: etyId }).then(({ emailTemplate }) => {
      entity.value = ety
      entityId.value = etyId

      email.value = {
        suggestions: [{
          group: 'Контрагент',
          users: emailTemplate.participant
        }, {
          group: 'Организатор',
          users: emailTemplate.organizer
        }],
        recipients: [],
        ccRecipients: [],
        subject: emailTemplate.subject,
        content: null,
        files: files
      }

      isEmailOpened.value = true
    })
  }

  const closeEmail = () => {
    isEmailOpened.value = false
  }

  const sendEmail = async () => {
    const emailInput = {
      recipients: email.value.recipients.map((r) => r.email),
      ccRecipients: email.value.ccRecipients.map((r) => r.email),
      subject: email.value.subject,
      content: email.value.content,
      filesIds: email.value.files.map((f) => f.id)
    }

    return DataService.sendEmail({ entity: entity.value, entityId: entityId.value, emailInput })
  }

  return {
    email,
    isEmailOpened,
    newEmail,
    closeEmail,
    sendEmail
  }
}
